import { z } from 'zod';
import { tagSchema } from './reception.js';
export const HANDLED_BY_VALUES = ['queue', 'human', 'ai'];
export const conversationSummarySchema = z.object({
    id: z.uuid(),
    contact: z.object({ id: z.uuid(), name: z.string(), maskedPhone: z.string().nullable(), instagram: z.string().nullable() }),
    channel: z.object({ id: z.uuid(), displayName: z.string(), kind: z.enum(['whatsapp', 'instagram']) }),
    /** Instagram: até quando dá para responder (24 h após a última mensagem da pessoa); null nos outros canais. */
    replyUntil: z.string().nullable(),
    status: z.enum(['open', 'closed']),
    handledBy: z.enum(HANDLED_BY_VALUES),
    assignedTo: z.object({ id: z.uuid(), name: z.string() }).nullable(),
    preview: z.string().nullable(),
    /** 'auto' = mensagem automática (confirmação, lembrete). */
    previewDirection: z.enum(['in', 'out', 'auto', 'ai']).nullable(),
    lastMessageAt: z.string(),
    /** Desde quando o paciente espera resposta (null = nada pendente). */
    waitingSince: z.string().nullable(),
    unreadCount: z.number().int(),
    tags: z.array(tagSchema),
});
export const INBOX_FILTERS = ['waiting', 'mine', 'open', 'closed'];
export const inboxCountsSchema = z.object({ waiting: z.number().int(), mine: z.number().int(), open: z.number().int() });
export const messageSchema = z.object({
    id: z.uuid(),
    direction: z.enum(['in', 'out']),
    senderType: z.enum(['contact', 'user', 'ai_agent', 'system', 'phone', 'automation']),
    senderName: z.string().nullable(),
    text: z.string().nullable(),
    status: z.enum(['received', 'queued', 'sent', 'delivered', 'read', 'failed']),
    /** Execução da IA que gerou a mensagem (para ver fontes e ferramentas usadas). */
    aiRunId: z.uuid().nullable().optional(),
    createdAt: z.string(),
});
export const sendMessageSchema = z.object({
    text: z.string().trim().min(1, 'Escreva a mensagem').max(4096, 'Mensagem longa demais para o WhatsApp'),
});
export const REALTIME_PATH = '/ws/socket.io';
// ------------------------------------------------------------------ simulador (somente dev)
export const devInboundSchema = z.object({
    channelAccountId: z.uuid(),
    phone: z.string().min(8).max(25),
    name: z.string().trim().min(1).max(80),
    text: z.string().trim().min(1).max(4096),
    /** Simula clique em anúncio Click-to-WhatsApp (Meta): o WhatsApp manda o título do anúncio. */
    adTitle: z.string().trim().max(120).optional(),
});
//# sourceMappingURL=inbox.js.map